// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Survey_ratings__C\\+2-w {
  display: flex;
  gap: 1rem;
  cursor: pointer;
  align-items: center;
  max-height: 6vh;
  margin: 4rem 0;
}
.Survey_ratings_active__7eZuH {
  padding: 1rem;
  transform: translateY(-1rem);
  transition: 0.5s;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Survey/Survey.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AADD;AAGC;EACC,aAAA;EACA,4BAAA;EACA,gBAAA;AADF","sourcesContent":["@import '../variables/breakpoints';\n\n.ratings {\n\tdisplay: flex;\n\tgap: 1rem;\n\tcursor: pointer;\n\talign-items: center;\n\tmax-height: 6vh;\n\tmargin: 4rem 0;\n\n\t&_active {\n\t\tpadding: 1rem;\n\t\ttransform: translateY(-1rem);\n\t\ttransition: 0.5s;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ratings": `Survey_ratings__C+2-w`,
	"ratings_active": `Survey_ratings_active__7eZuH`
};
export default ___CSS_LOADER_EXPORT___;
